import { getApi } from '@/api'
import { cloneDeep } from "lodash";

export default {

  // REMOVE_PARTNER: ({ commit }, payload) => {
  //   return new Promise((resolve, reject) => {
  //     api
  //       .delete('/partners/' + payload)
  //       .then(() => {
  //         // commit('REMOVE_PARTNER', payload);
  //         resolve();
  //       })
  //       .catch(err => {
  //         reject(err);
  //       });
  //   })
  // },


  // PREPARE_EDIT_PARTNER_CONTACT_DETAIL: ({ commit, state, rootState }, { partner, isNew, entity }) => {
  //   return new Promise((resolve, reject) => {
  //     let updatedPartner = {
  //       _id: partner._id,
  //       contactDetails: cloneDeep(partner.contactDetails)
  //     };
  //     commit("ADD_EDITABLE_ENTITY", {
  //       entity: updatedPartner,
  //       schema: "partnerSchema"
  //     }, { root: true });
  //     if (isNew) {
  //       updatedPartner.contactDetails.push(entity._id);
  //       commit("UPDATE_ENTITY", {
  //         id: updatedPartner._id,
  //         entityType: "partners",
  //         updatedFields: updatedPartner
  //       }, { root: true });
  //       commit("ADD_EDITABLE_ENTITY", {
  //         entity,
  //         schema: "contactDetailSchema"
  //       }, { root: true });
  //     }
  //     commit("SET_ENTITY_EDIT_DATA", {
  //       id: entity._id,
  //       mainId: partner._id,
  //       mainResource: rootState.resources.partner,
  //       resource: rootState.resources.contactDetail,
  //       isNew
  //     }, { root: true });
  //     resolve();
  //   })
  // },

  // REMOVE_PARTNER_CONTACT_DETAIL: ({ commit, state, rootState }, { partner, isNew, entity }) => {
  //   return new Promise((resolve, reject) => {
  //     let updatedPartner = {
  //       _id: partner._id,
  //       contactDetails: cloneDeep(partner.contactDetails)
  //     };
  //     commit("ADD_EDITABLE_ENTITY", {
  //       entity: updatedPartner,
  //       schema: "partnerSchema"
  //     }, { root: true });
  //     if (isNew) {
  //       updatedPartner.contactDetails.push(entity._id);
  //       commit("UPDATE_ENTITY", {
  //         id: updatedPartner._id,
  //         entityType: "partners",
  //         updatedFields: updatedPartner
  //       }, { root: true });
  //       commit("ADD_EDITABLE_ENTITY", {
  //         entity,
  //         schema: "contactDetailSchema"
  //       }, { root: true });
  //     }
  //     commit("SET_ENTITY_EDIT_DATA", {
  //       id: entity._id,
  //       mainId: partner._id,
  //       mainResource: rootState.resources.partner,
  //       resource: rootState.resources.contactDetail,
  //       isNew
  //     }, { root: true });
  //     resolve();
  //   })
  // },

  // FETCH_PARTNER: ({ commit, dispatch }, payload) => {
  //   commit('SET_FETCHING_PARTNER', true);
  //   api
  //     .get('/partners/' + payload)
  //     .then(({ data }) => {
  //       commit('SET_PARTNER', data.result);
  //     })
  //     .catch(err => {
  //       dispatch('SHOW_SNACKBAR', {
  //         text: err.message,
  //         color: 'error'
  //       },
  //         { root: true });
  //     })
  //     .finally(() => {
  //       commit('SET_FETCHING_PARTNER', false);
  //     });
  // },

  // SAVE_PARTNER_TO_SERVER: ({ state, commit }) => {
  //   commit('SET_SAVING', true);
  //   let params = state.editablePartner;
  //   api
  //     .patch(`/partners/${params._id}`, params)
  //     .then(({ data }) => {
  //       commit('SET_PARTNER', data.result);
  //       commit('TOGGLE_EDIT_PARTNER_DIALOG', false);
  //     })
  //     .catch(err => {
  //       dispatch('SHOW_SNACKBAR', {
  //         text: err.message,
  //         color: 'error'
  //       }, { root: true });
  //     })
  //     .finally(() => {
  //       commit('SET_SAVING', false);
  //     });
  // },

};


// WEBPACK FOOTER //
// ./src/store/partners/actions.js